import gql from 'graphql-tag'

export default gql`
  mutation createOrder(
    $addressId: ID
    $storeId: ID
    $menuId: ID
    $deliveryType: String
    $time: String
    $paymentType: String
    $otherPaymentType: String
    $tipAmount: Float
    $cashAmount: Float
    $cardId: ID
    $channel: String
    $chatCommerceType: String
    $couponCode: ID
    $dropOffType: String
    $tableName: String
    $orderParams: JSON
    $billing: JSON
    $termSignatures: [TermSignatureInput]
    $idempotencyKey: ID
    $paymentData: JSON
    $sessionEmail: String
    $sessionPhone: String
    $orderGroupId: ID
    $isTableOrderV2: Boolean
    $gift: GiftInput
    $source: String
  ) {
    order: createOrder(
      addressId: $addressId
      storeId: $storeId
      menuId: $menuId
      deliveryType: $deliveryType
      time: $time
      paymentType: $paymentType
      cashAmount: $cashAmount
      channel: $channel
      chatCommerceType: $chatCommerceType
      couponCode: $couponCode
      otherPaymentType: $otherPaymentType
      cardId: $cardId
      tipAmount: $tipAmount
      dropOffType: $dropOffType
      tableName: $tableName
      orderParams: $orderParams
      billing: $billing
      termSignatures: $termSignatures
      idempotencyKey: $idempotencyKey
      paymentData: $paymentData
      sessionEmail: $sessionEmail
      sessionPhone: $sessionPhone
      orderGroupId: $orderGroupId
      isTableOrderV2: $isTableOrderV2
      gift: $gift
      source: $source
    ) {
      _id
      code
      paymentStatus
      paymentType
      totalPrice
      totalItems
      amountToPay
      tipAmount
      tableName
      dropOffType
      deliveryFee
      orderGroupId
      isTableOrderV2
      items {
        product {
          _id
          name
          categories {
            _id
            internalName
          }
        }
        amount
        unitPrice
      }
      transaction {
        _id
        publicMeta
      }
      intent {
        _id
        intentPayload
      }
    }
  }
`
